// import globalIP from '@/GlobelIP';
// import React, { useEffect } from 'react';

// export default function useFilters(
//   selectedCategory,
//   selectedProductType,
//   selectedColor,
//   selectedFinish,
//   selectedAlias,
//   setAliasdata,
//   setFinishdata,
//   setColordata,
//   setCategorydata,
//   setProductypedata,
//   endpoint) {
// const urlendpoint=endpoint=='variant'?"variant-products":'products';
//   useEffect(() => {
//     fetchFilteredAlias();
//   }, [selectedCategory,
//     selectedColor,
//     selectedProductType,
//     selectedFinish]);
//   useEffect(() => {
//     fetchFilteredfinish();
//   }, [selectedCategory,
//     selectedColor,
//     selectedProductType,
//     selectedAlias]);
//   useEffect(() => {
//     fetchFilteredcolor();
//   }, [selectedCategory,
//     selectedFinish,
//     selectedProductType,
//     selectedAlias]);

//   let categoryFilter = '';
//   if (selectedCategory.length > 0) {
//     const categoryFilterString = selectedCategory
//       .map(cat => `filters[CategoryCode][$eq]=${cat}`)
//       .join('&');
//     categoryFilter = `&${categoryFilterString}`;
//   }
//   let producttypeFilter = '';
//   if (selectedProductType.length > 0) {
//     const ptypeFilterString = selectedProductType
//       .map(cat => `filters[ProductTypeCode][$eq]=${cat}`)
//       .join('&');
//     producttypeFilter = `&${ptypeFilterString}`;
//   }
//   let colorFilter = '';
//   if (selectedColor.length > 0) {
//     const colorFilterString = selectedColor
//       .map(cat => `filters[ColorCode][$eq]=${cat}`)
//       .join('&');
//     colorFilter = `&${colorFilterString}`;
//   }
//   let finishFilter = '';
//   if (selectedFinish.length > 0) {
//     const finishFilterString = selectedFinish
//       .map(cat => `filters[FinishCode][$eq]=${cat}`)
//       .join('&');
//     finishFilter = `&${finishFilterString}`;
//   }
//   let aliasFilter = '';
//   if (selectedAlias.length > 0) {
//     const aliasFilterString = selectedAlias
//       .map(cat => `filters[ProductId][$eq]=${cat}`)
//       .join('&');
//     aliasFilter = `&${aliasFilterString}`;
//   }


//   const fetchFilteredAlias = async () => {
//     try {
//       const response = await fetch(`${globalIP}/api/${urlendpoint}?&sort[0]=ProductId&pagination[page]=1&fields[0]=ProductId&${categoryFilter}${colorFilter}${producttypeFilter}${finishFilter}`);
//       const json = await response.json();
//       const allData = [];

//       for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
//         const pageResponse = await fetch(
//           `${globalIP}/api/${urlendpoint}?&sort[0]=ProductId&pagination[page]=${page}&fields[0]=ProductId&${categoryFilter}${colorFilter}${producttypeFilter}${finishFilter}`
//         );
//         const pageJson = await pageResponse.json();
//         const processedData = pageJson.data
//           .filter(item => item.attributes.ProductId !== '' && item.attributes.ProductId !== null)
//           .map(item => ({
//             label: item.attributes.ProductId,
//             value: item.attributes.ProductId
//           }));
//         processedData.forEach(item => {
//           if (!allData.some(existingItem => existingItem.label === item.label)) {
//             allData.push(item);
//           }
//         });
//       }

//       setAliasdata(allData);
//     } catch (error) {
//       console.error('Error fetching filtered products:', error);
//     }
//   };

//   const fetchFilteredfinish = async () => {
//     try {
//       const response = await fetch(`${globalIP}/api/${urlendpoint}?&sort[0]=FinishName&pagination[page]=1&fields[0]=FinishName&fields[1]=FinishCode${categoryFilter}${colorFilter}${producttypeFilter}${aliasFilter}`);
//       const json = await response.json();
//       const allData = [];

//       for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
//         const pageResponse = await fetch(
//           `${globalIP}/api/${urlendpoint}?&sort[0]=FinishName&pagination[page]=${page}&fields[0]=FinishName&fields[1]=FinishCode${categoryFilter}${colorFilter}${producttypeFilter}${aliasFilter}`
//         );
//         const pageJson = await pageResponse.json();
//         const processedData = pageJson.data
//           .filter(item => item.attributes.FinishName !== '' && item.attributes.FinishName !== null)
//           .map(item => ({
//             label: item.attributes.FinishName,
//             value: item.attributes.FinishCode
//           }));
//         processedData.forEach(item => {
//           if (!allData.some(existingItem => existingItem.label === item.label)) {
//             allData.push(item);
//           }
//         });
//       }
//       setFinishdata(allData);
//     } catch (error) {
//       console.error('Error fetching filtered products:', error);
//     }
//   };

//   const fetchFilteredcolor = async () => {
//     try {
//       const response = await fetch(`${globalIP}/api/${urlendpoint}?&sort[0]=ColorName&pagination[page]=1&fields[0]=ColorName&fields[1]=ColorCode&${categoryFilter}${finishFilter}${producttypeFilter}${aliasFilter}`);
//       const json = await response.json();
//       const allData = [];

//       for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
//         const pageResponse = await fetch(
//           `${globalIP}/api/${urlendpoint}?&sort[0]=ColorName&pagination[page]=${page}&fields[0]=ColorName&fields[1]=ColorCode&{categoryFilter}${finishFilter}${producttypeFilter}${aliasFilter}`
//         );
//         const pageJson = await pageResponse.json();
//         const processedData = pageJson.data.filter(item => item.attributes.ColorName !== '' && item.attributes.ColorName !== null)
//           .map(item => ({
//             label: item.attributes.ColorName,
//             value: item.attributes.ColorCode
//           }));
//         processedData.forEach(item => {
//           if (!allData.some(existingItem => existingItem.label === item.label)) {
//             allData.push(item);
//           }
//         });
//       }
//       setColordata(allData);
//     } catch (error) {
//       console.error('Error fetching filtered products:', error);
//     }
//   };
//   useEffect(() => {
//     fetchFilteredcategory();
//   }, [selectedColor,
//     selectedFinish,
//     selectedProductType,
//     selectedAlias]);

//   const fetchFilteredcategory = async () => {
//     try {
//       const response = await fetch(`${globalIP}/api/${urlendpoint}?&sort[0]=CategoryName&pagination[page]=1&fields[0]=CategoryName&fields[1]=CategoryCode&${colorFilter}${finishFilter}${producttypeFilter}${aliasFilter}`);
//       const json = await response.json();
//       const allData = [];

//       for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
//         const pageResponse = await fetch(
//           `${globalIP}/api/${urlendpoint}?&sort[0]=CategoryName&pagination[page]=${page}&fields[0]=CategoryName&fields[1]=CategoryCode&${colorFilter}${finishFilter}${producttypeFilter}${aliasFilter}`
//         );
//         const pageJson = await pageResponse.json();
//         const processedData = pageJson.data.filter(item => item.attributes.CategoryName !== '' && item.attributes.CategoryName !== null)
//           .map(item => ({
//             label: item.attributes.CategoryName,
//             value: item.attributes.CategoryCode
//           }));
//         processedData.forEach(item => {
//           if (!allData.some(existingItem => existingItem.label === item.label)) {
//             allData.push(item);
//           }
//         });
//       }
//       setCategorydata(allData);
//     } catch (error) {
//       console.error('Error fetching filtered products:', error);
//     }
//   };
//   useEffect(() => {
//     fetchFilteredProductType();
//   }, [selectedColor,
//     selectedFinish,
//     selectedCategory,
//     selectedAlias]);

//   const fetchFilteredProductType = async () => {
//     try {
//       const response = await fetch(`${globalIP}/api/${urlendpoint}?&sort[0]=ProductTypeName&pagination[page]=1&fields[0]=ProductTypeName&fields[1]=ProductTypeCode&${colorFilter}${finishFilter}${categoryFilter}${aliasFilter}`);
//       const json = await response.json();
//       const allData = [];

//       for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
//         const pageResponse = await fetch(
//           `${globalIP}/api/${urlendpoint}?&sort[0]=ProductTypeName&pagination[page]=${page}&fields[0]=ProductTypeName&fields[1]=ProductTypeCode&${colorFilter}${finishFilter}${categoryFilter}${aliasFilter}`
//         );
//         const pageJson = await pageResponse.json();
//         const processedData = pageJson.data.filter(item => item.attributes.ProductTypeName !== '' && item.attributes.ProductTypeName !== null)
//           .map(item => ({
//             label: item.attributes.ProductTypeName,
//             value: item.attributes.ProductTypeCode
//           }));
//         processedData.forEach(item => {
//           if (!allData.some(existingItem => existingItem.label === item.label)) {
//             allData.push(item);
//           }
//         });
//       }
//       setProductypedata(allData);
//     } catch (error) {
//       console.error('Error fetching filtered products:', error);
//     }
//   };
// }

import globalIP from '@/GlobelIP';
import React, { useEffect } from 'react';

export default function useFilters(
  selectedCategory,
  selectedProductType,
  selectedColor,
  selectedFinish,
  selectedAlias,
  setAliasdata,
  setFinishdata,
  setColordata,
  setCategorydata,
  setProductypedata,
  endpoint
) {
  const urlendpoint = endpoint == 'variant' ? "variant-products" : 'products';

  // Build filter strings
  let categoryFilter = '';
  if (selectedCategory.length > 0) {
    categoryFilter = '&' + selectedCategory.map(cat => `filters[CategoryCode][$eq]=${cat}`).join('&');
  }

  let producttypeFilter = '';
  if (selectedProductType.length > 0) {
    producttypeFilter = '&' + selectedProductType.map(cat => `filters[ProductTypeCode][$eq]=${cat}`).join('&');
  }

  let colorFilter = '';
  if (selectedColor.length > 0) {
    colorFilter = '&' + selectedColor.map(cat => `filters[ColorCode][$eq]=${cat}`).join('&');
  }

  let finishFilter = '';
  if (selectedFinish.length > 0) {
    finishFilter = '&' + selectedFinish.map(cat => `filters[FinishCode][$eq]=${cat}`).join('&');
  }

  let aliasFilter = '';
  if (selectedAlias.length > 0) {
    aliasFilter = '&' + selectedAlias.map(cat => `filters[ProductId][$eq]=${cat}`).join('&');
  }

  // ✅ OPTIMIZED: Single API call with large page size, no loops
  const fetchFilteredAlias = async () => {
    try {
      const response = await fetch(
        `${globalIP}/api/${urlendpoint}?sort[0]=ProductId&pagination[pageSize]=10000&fields[0]=ProductId${categoryFilter}${colorFilter}${producttypeFilter}${finishFilter}`
      );
      const json = await response.json();
      
      const processedData = json.data
        .filter(item => item.attributes.ProductId && item.attributes.ProductId.trim() !== '')
        .map(item => ({
          label: item.attributes.ProductId,
          value: item.attributes.ProductId
        }));

      // Remove duplicates
      const uniqueData = processedData.filter((item, index, self) => 
        index === self.findIndex(t => t.label === item.label)
      );

      setAliasdata(uniqueData);
    } catch (error) {
      console.error('Error fetching filtered alias:', error);
    }
  };

  // ✅ OPTIMIZED: Single API call
  const fetchFilteredFinish = async () => {
    try {
      const response = await fetch(
        `${globalIP}/api/${urlendpoint}?sort[0]=FinishName&pagination[pageSize]=10000&fields[0]=FinishName&fields[1]=FinishCode${categoryFilter}${colorFilter}${producttypeFilter}${aliasFilter}`
      );
      const json = await response.json();
      
      const processedData = json.data
        .filter(item => item.attributes.FinishName && item.attributes.FinishName.trim() !== '')
        .map(item => ({
          label: item.attributes.FinishName,
          value: item.attributes.FinishCode
        }));

      const uniqueData = processedData.filter((item, index, self) => 
        index === self.findIndex(t => t.label === item.label)
      );

      setFinishdata(uniqueData);
    } catch (error) {
      console.error('Error fetching filtered finish:', error);
    }
  };

  // ✅ OPTIMIZED: Single API call
  const fetchFilteredColor = async () => {
    try {
      const response = await fetch(
        `${globalIP}/api/${urlendpoint}?sort[0]=ColorName&pagination[pageSize]=10000&fields[0]=ColorName&fields[1]=ColorCode${categoryFilter}${finishFilter}${producttypeFilter}${aliasFilter}`
      );
      const json = await response.json();
      
      const processedData = json.data
        .filter(item => item.attributes.ColorName && item.attributes.ColorName.trim() !== '')
        .map(item => ({
          label: item.attributes.ColorName,
          value: item.attributes.ColorCode
        }));

      const uniqueData = processedData.filter((item, index, self) => 
        index === self.findIndex(t => t.label === item.label)
      );

      setColordata(uniqueData);
    } catch (error) {
      console.error('Error fetching filtered color:', error);
    }
  };

  // ✅ OPTIMIZED: Single API call
  const fetchFilteredCategory = async () => {
    try {
      const response = await fetch(
        `${globalIP}/api/${urlendpoint}?sort[0]=CategoryName&pagination[pageSize]=10000&fields[0]=CategoryName&fields[1]=CategoryCode${colorFilter}${finishFilter}${producttypeFilter}${aliasFilter}`
      );
      const json = await response.json();
      
      const processedData = json.data
        .filter(item => item.attributes.CategoryName && item.attributes.CategoryName.trim() !== '')
        .map(item => ({
          label: item.attributes.CategoryName,
          value: item.attributes.CategoryCode
        }));

      const uniqueData = processedData.filter((item, index, self) => 
        index === self.findIndex(t => t.label === item.label)
      );

      setCategorydata(uniqueData);
    } catch (error) {
      console.error('Error fetching filtered category:', error);
    }
  };

  // ✅ OPTIMIZED: Single API call
  const fetchFilteredProductType = async () => {
    try {
      const response = await fetch(
        `${globalIP}/api/${urlendpoint}?sort[0]=ProductTypeName&pagination[pageSize]=10000&fields[0]=ProductTypeName&fields[1]=ProductTypeCode${colorFilter}${finishFilter}${categoryFilter}${aliasFilter}`
      );
      const json = await response.json();
      
      const processedData = json.data
        .filter(item => item.attributes.ProductTypeName && item.attributes.ProductTypeName.trim() !== '')
        .map(item => ({
          label: item.attributes.ProductTypeName,
          value: item.attributes.ProductTypeCode
        }));

      const uniqueData = processedData.filter((item, index, self) => 
        index === self.findIndex(t => t.label === item.label)
      );

      setProductypedata(uniqueData);
    } catch (error) {
      console.error('Error fetching filtered product type:', error);
    }
  };

  // Effects to trigger API calls when dependencies change
  useEffect(() => {
    fetchFilteredAlias();
  }, [selectedCategory, selectedColor, selectedProductType, selectedFinish]);

  useEffect(() => {
    fetchFilteredFinish();
  }, [selectedCategory, selectedColor, selectedProductType, selectedAlias]);

  useEffect(() => {
    fetchFilteredColor();
  }, [selectedCategory, selectedFinish, selectedProductType, selectedAlias]);

  useEffect(() => {
    fetchFilteredCategory();
  }, [selectedColor, selectedFinish, selectedProductType, selectedAlias]);

  useEffect(() => {
    fetchFilteredProductType();
  }, [selectedColor, selectedFinish, selectedCategory, selectedAlias]);
}
